// Shared theme + color palette for dashboard charts. Keep this tiny — each
// chart pulls the exact tokens it needs. Colors resolve to CSS custom
// properties where possible so dark mode flips for free; fallbacks are given
// so that charts still look reasonable outside the app shell (e.g. in tests
// or Storybook).

export const SERIES_PALETTE = [
  "#5b7cfa", // indigo — primary
  "#2ca87f", // green — success
  "#f5a623", // amber — warning
  "#e5484d", // red — danger
  "#8e44ec", // purple — accent
  "#00b4d8", // cyan
  "#ff7a45", // orange
  "#7c93a6", // slate
];

export const seriesColor = (i) => SERIES_PALETTE[i % SERIES_PALETTE.length];

// Sequential scale for heatmaps / magnitude. Start light, end saturated.
export const SEQUENTIAL = ["#eef2ff", "#c7d2fe", "#818cf8", "#5b7cfa", "#3b5bdb"];

// Diverging scale for agreement (red → amber → green). Useful for IAA / score
// charts where both low and high extremes matter.
export const DIVERGING = ["#e5484d", "#f5a623", "#eab308", "#86be4b", "#2ca87f"];

// Flat tokens for axis lines, gridlines, tooltip chrome.
//
// These are CSS custom properties (defined in app/App.prefix.css for
// light AND dark) so charts flip with the theme. They were hardcoded
// light-theme rgba literals for a long time — in dark mode axis
// labels, gridlines, and the analytics range picker were near-
// invisible on every dashboard. Fallbacks keep tests / Storybook
// readable outside the app shell. SVG ``fill``/``stroke`` accept
// ``var()`` in every browser we ship to.
export const CHART_TOKENS = {
  grid: "var(--chart-grid, rgba(21, 24, 35, 0.06))",
  axis: "var(--chart-axis, rgba(21, 24, 35, 0.24))",
  label: "var(--chart-label, rgba(21, 24, 35, 0.6))",
  labelStrong: "var(--chart-label-strong, rgba(21, 24, 35, 0.9))",
  tooltipBg: "var(--chart-tooltip-bg, rgba(20, 24, 35, 0.94))",
  tooltipFg: "var(--chart-tooltip-fg, #fff)",
  // Segmented-control track (range pickers, view toggles in charts).
  track: "var(--chart-track, rgba(21, 24, 35, 0.04))",
};

export const fmtInt = (n) => (n == null ? "—" : Number(n).toLocaleString());
export const fmtPct = (n) => (n == null ? "—" : `${Math.round(n * 100)}%`);
export const fmtFloat = (n, d = 2) =>
  n == null
    ? "—"
    : Number(n)
        .toFixed(d)
        .replace(/\.?0+$/, "");
